import React from "react";
import { Table } from "antd";
// import AllNodata from "../../../assets/All_NoData.svg";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";

const { Column } = Table;

const TicketTable = ({
  tableColumns,
  dataSource,
  widget_id,
  setWidgetLevelName,
  widgetLevelName,
  level,
  setLevel,
  setLevel3,
  LevelTabletitle2,
  LevelTabletitle3,
  pageSize,
}) => {
  let combinedName = widget_id + "_" + level;

  const handleShowGrid = (name) => {
    let data = name == 0 ? 0 : name?.toLowerCase().split(" ").join("_");
    setWidgetLevelName(data);
    setLevel(level);
    if (level == 2) {
      setLevel(level);
      setLevel3();
    } else {
      setLevel(level);
    }
    var elmntToView = document?.getElementById(combinedName);
    elmntToView?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="widgetmaker-grid-chart mb-0">
      <div className="p-0">
        {widget_id === "tickets_overview_5" ||
        widget_id === "tickets_overview_6" ? (
          <>
            {LevelTabletitle2 && (
              <div className="portlet__title fontSize-16 font-weight500 w-100 pt-15 pb-15 pr-15">
                {LevelTabletitle2}
              </div>
            )}
            {LevelTabletitle3 && (
              <div className="portlet__title fontSize-16 font-weight500 w-100 pt-15 pb-15 pr-15">
                {LevelTabletitle3}
              </div>
            )}

            {tableColumns?.length > 0 ? (
              <Table
                dataSource={dataSource}
                //bordered
                className="custom_table_scroll mt-15"
                scroll={{
                  x: 1000,
                  y: widget_id && dataSource?.length > 10 ? 400 : undefined,
                }}
                pagination={false}
              >
                {tableColumns?.map((col, i) => {
                  return (
                    <Column
                      title={col?.title}
                      dataIndex={col?.title}
                      key={i}
                      render={(value) => (
                        <>
                          <span
                            id={combinedName}
                            className={
                              level !== "4" && i === 0 ? `cursor-pointer` : ""
                            }
                            style={{
                              color: level !== "4" && i === 0 ? "#185edf" : "",
                              borderBottom:
                                level !== "4" && i === 0
                                  ? "0.1rem solid #185edf"
                                  : "",
                            }}
                            key={value}
                            onClick={
                              level !== "4" && i == 0
                                ? () => handleShowGrid(value)
                                : ""
                            }
                          >
                            {value}
                          </span>
                        </>
                      )}
                    />
                  );
                })}
              </Table>
            ) : (
              <div className="d-flex full_nodata align-items-center">
                <div className="w-100 text-center">
                  <div className="Nodata_img mb-15">
                    <img src={somethingWentWrong} alt="no data" />
                  </div>
                  <div className="text_regular-gray">No Data Found</div>
                </div>
              </div>
            )}
          </>
        ) : tableColumns?.length > 0 ? (
          <Table
            dataSource={dataSource}
            pagination={{
              hideOnSinglePage: dataSource?.length > 10 ? false : true,
              defaultPageSize: pageSize ? pageSize : 10,
              pageSize: pageSize ? pageSize : 10,
              showSizeChanger: false,
              // pageSizeOptions: ["10", "20", "30", "40", "50"],
              // locale: { items_per_page: "/ Page" },
              total: dataSource?.length,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total}`,
            }}
            // pagination={
            //   tableColumns?.length <= 10
            //     ? false
            //     : (widget_id === "tickets_overview_7" ||
            //         widget_id === "tickets_overview_9") && {
            //         pageSize: pageSize ? pageSize : 10,
            //       }
            // }
            columns={tableColumns}
            //bordered
            className="custom_table_scroll mt-15"
            scroll={
              widget_id === "tickets_overview_9" // to fix CSS issue for ticket overview
                ? {
                    x: 2500,
                    y: widget_id && dataSource?.length > 10 ? 400 : undefined,
                  }
                : {
                    x: 1000,
                    y: widget_id && dataSource?.length > 10 ? 400 : undefined,
                  }
            }
          />
        ) : (
          <div className="d-flex full_nodata align-items-center">
            <div className="w-100 text-center">
              <div className="Nodata_img mb-15">
                <img src={somethingWentWrong} alt="no data" />
              </div>
              <div className="text_regular-gray">No Data Found</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketTable;
